import * as React from 'react';
import { cn } from '@/lib/utils';

interface Props {
  label: string;
  value?: React.ReactNode;
  className?: string;
  children?: React.ReactNode;
}

export function DetailField({ label, value, className, children }: Props) {
  return (
    <div className={cn('space-y-0.5', className)}>
      <div className="text-[11px] font-medium uppercase tracking-wider text-muted-foreground">
        {label}
      </div>
      <div className="text-sm text-foreground">{value ?? children ?? '—'}</div>
    </div>
  );
}
